import { Product } from '../schemas';

/**
 * SUBAGENTE 5: SCHEMA.ORG JSON-LD & SEO GENERATOR
 * Generates Google-compliant rich snippet structured data for Products, AggregateOffers, and Breadcrumbs.
 */

export function generateProductJsonLd(product: Product, currentCurrency = 'USD', currencyRate = 1.0) {
  const convertedLowPrice = (product.bestPriceUSD * currencyRate).toFixed(2);
  const convertedHighPrice = (product.highestPriceUSD * currencyRate).toFixed(2);

  return {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    'name': product.title,
    'image': product.images,
    'description': product.description,
    'sku': product.id,
    'mpn': product.mpn || product.id,
    'brand': {
      '@type': 'Brand',
      'name': product.brand,
    },
    'aggregateRating': {
      '@type': 'AggregateRating',
      'ratingValue': product.rating,
      'reviewCount': Math.max(1, product.reviewsCount),
      'bestRating': '5',
      'worstRating': '1',
    },
    'offers': {
      '@type': 'AggregateOffer',
      'priceCurrency': currentCurrency === 'USD' ? 'USD' : 'ARS',
      'lowPrice': convertedLowPrice,
      'highPrice': convertedHighPrice,
      'offerCount': product.offersCount,
      'offers': product.offers.map((offer) => ({
        '@type': 'Offer',
        'price': (offer.priceUSD * currencyRate).toFixed(2),
        'priceCurrency': currentCurrency === 'USD' ? 'USD' : 'ARS',
        'itemCondition': 'https://schema.org/NewCondition',
        'availability':
          offer.stockStatus === 'in_stock'
            ? 'https://schema.org/InStock'
            : offer.stockStatus === 'low_stock'
            ? 'https://schema.org/LimitedAvailability'
            : 'https://schema.org/OutOfStock',
        'seller': {
          '@type': 'Organization',
          'name': offer.storeName,
        },
        'url': `https://www.comprasparaguay.com.ar/api/out?url=${encodeURIComponent(
          offer.productUrl
        )}&storeId=${offer.storeId}&prodId=${product.id}`,
      })),
    },
  };
}

export function generateBreadcrumbJsonLd(items: { name: string; url: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': items.map((item, index) => ({
      '@type': 'ListItem',
      'position': index + 1,
      'name': item.name,
      'item': item.url,
    })),
  };
}
